import React, { Component,Fragment } from 'react';
import axios from 'axios';
import { connect } from 'react-redux'
import { AUTH_CONFIG } from '../../Auth/auth0-variables';
import Loading from '../Loading';
export class Invoices extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            payments: [],
            isFetching:true
        };
    }
    componentDidMount() {
        axios.get(AUTH_CONFIG.API_URL + "/api/Stripe/RecentPayments?facilityId=" + this.props.facilityId)
            .then((response) => {
                this.setState({
                    payments: response.data,
                    isFetching:false
                });
            });
    }

    render() {
        return (
            <Fragment>
            <table class="billing-subscriptions-table  billing-subscriptions__table table">
                <colgroup>
                    <col class="billing-subscriptions-table__col-app-name" />
                    <col class="billing-subscriptions-table__col-plan-name" />
                    <col class="billing-subscriptions-table__col-price" />
                </colgroup>
                <thead>
                    <tr>
                        <th>Product name</th>
                        <th>Amount</th>
                        <th>Date/month</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.payments &&
                        this.state.payments.map((n) => {
                            return (
                                <tr class="billing-subscription-row">
                                    <td>{n.productName}</td>
                                    <td>
                                        ${n.amount}
                                    </td>
                                    <td>{n.date}</td>
                                </tr>
                            )
                        })
                    }
                    
                </tbody>
            </table>
                <div style={{width:'100%', textAlign:'center', marginTop:'100px'}}>
                    {!this.state.isFetching && this.state.payments && this.state.payments.length == 0 &&
                    <h2>No Invoices yet</h2>
                }
            </div>
        </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    facilityId: state.appState.product.facility.facilityID
});

export default connect(mapStateToProps)(Invoices);



